import PullRequests from 'components/pull-requests';

const PullRequestsPage = () => {
  return <PullRequests />;
};

export default PullRequestsPage;
